export default {
  joinFilterValues(filter) {
    const { filterValues } = filter;

    return filterValues.map(filterValue => {
      const { value } = filterValue;

      /**
       * Since pipe is a valid value character, replace
       * all single pipes with the escaped version (`\\|`)
       * and then join them by single pipe (`|`) so it becomes an OR expression.
       *
       * i.e.
       * - `Value A|Value B`
       * - `Value C`
       *
       * results in:
       *
       * `Value A\\|Value B|Value C`
       */
      return typeof value === 'string'
        ? value.replaceAll(/\|/g, '\\|')
        : value;
    }).join('|');
  },

  /**
   * The operator needs to change to `in` when multiple filterValues found
   * since the API doesn't support `eq` when doing an OR; otherwise, use the `operator`.
   */
  translateOperator(filter) {
    const { operator, filterValues } = filter;

    return operator === 'eq' && filterValues?.length > 1 ? 'in' : operator;
  },
};
